import React from "react";
import { ecosystemSpine, ecosystemOrbit } from "../data/content";

export default function EcosystemMap() {
  const leftCol = ecosystemSpine.filter((_, i) => i % 2 === 0);
  const rightCol = ecosystemSpine.filter((_, i) => i % 2 === 1);

  return (
    <section className="section-py bg-lavender">
      <div className="container text-center">
        <h2 className="section-title">The SELECTEZI Ecosystem Map</h2>
        <p className="section-subtitle">
          An architectural spine linking base supply through customer
          fulfilment, flanked by institutional enablers
        </p>

        <div className="row g-4 mt-3 text-start">
          <div className="col-md-6">
            {leftCol.map((row) => (
              <div
                className={`spine-row${row.highlight ? " highlight" : ""}`}
                key={row.num}
              >
                <span className="spine-num">{row.num}</span>
                <span className="spine-title">{row.title}</span>
                <span className="spine-desc">{row.desc}</span>
              </div>
            ))}
          </div>
          <div className="col-md-6">
            {rightCol.map((row) => (
              <div
                className={`spine-row${row.highlight ? " highlight" : ""}`}
                key={row.num}
              >
                <span className="spine-num">{row.num}</span>
                <span className="spine-title">{row.title}</span>
                <span className="spine-desc">{row.desc}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="orbit-box text-start">
          <h5 className="fw-bold mb-1">SURROUNDING ECOSYSTEM ORBIT</h5>
          <p className="text-muted mb-0" style={{ fontSize: "0.9rem" }}>
            Continuous infrastructural layers supporting every vertical node
            along the commercial path:
          </p>
          <div className="orbit-tags">
            {ecosystemOrbit.map((tag) => (
              <span className="orbit-tag" key={tag}>
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
